/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DailyTaskSlotDto } from './DailyTaskSlotDto';
import {
    DailyTaskSlotDtoFromJSON,
    DailyTaskSlotDtoFromJSONTyped,
    DailyTaskSlotDtoToJSON,
    DailyTaskSlotDtoToJSONTyped,
} from './DailyTaskSlotDto';

/**
 * 
 * @export
 * @interface TodayTasksResponseDto
 */
export interface TodayTasksResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof TodayTasksResponseDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof TodayTasksResponseDto
     */
    timezone: string;
    /**
     * 
     * @type {Array<DailyTaskSlotDto>}
     * @memberof TodayTasksResponseDto
     */
    slots: Array<DailyTaskSlotDto>;
    /**
     * Current slot, or the next slot after the current time window has ended
     * @type {DailyTaskSlotDto}
     * @memberof TodayTasksResponseDto
     */
    upNext?: DailyTaskSlotDto | null;
}

/**
 * Check if a given object implements the TodayTasksResponseDto interface.
 */
export function instanceOfTodayTasksResponseDto(value: object): value is TodayTasksResponseDto {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    if (!('slots' in value) || value['slots'] === undefined) return false;
    return true;
}

export function TodayTasksResponseDtoFromJSON(json: any): TodayTasksResponseDto {
    return TodayTasksResponseDtoFromJSONTyped(json, false);
}

export function TodayTasksResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TodayTasksResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'timezone': json['timezone'],
        'slots': ((json['slots'] as Array<any>).map(DailyTaskSlotDtoFromJSON)),
        'upNext': json['upNext'] == null ? undefined : DailyTaskSlotDtoFromJSON(json['upNext']),
    };
}

export function TodayTasksResponseDtoToJSON(json: any): TodayTasksResponseDto {
    return TodayTasksResponseDtoToJSONTyped(json, false);
}

export function TodayTasksResponseDtoToJSONTyped(value?: TodayTasksResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': ((value['date']).toISOString().substring(0,10)),
        'timezone': value['timezone'],
        'slots': ((value['slots'] as Array<any>).map(DailyTaskSlotDtoToJSON)),
        'upNext': DailyTaskSlotDtoToJSON(value['upNext']),
    };
}

